import { Deployment } from 'src/components/pipelines/models';

// Fixes wrong redeploy API url
export default function (deployment: Deployment) {
  const url = deployment.state.url || '';
  return url.replace(
    /results\/(\d+)\/steps\/(.*)\/redeploy$/,
    `results/$1/steps/${deployment.step.uuid}/redeploy`
  );
}
